import noop from "lodash/noop";

import { OnboardingVerifyInfoTestID, TextTestID } from "@/constants/TestID";
import type { UserOverviewCardProps } from "@/ui/components/profile";
import UserOverviewCard from "@/ui/components/profile/UserOverviewCard";
import { Button, FAIconName, Text } from "@/ui/core";
import { VStack } from "@/ui/layout";
import { ColorToken } from "@/ui/theme/tokens";
import { joinTestIDs } from "@/utils/string.util";

interface OnboardingVerifyInfoPageProps {
  onNextPress?: () => void;
  proxyPatientProfileOverviews?: UserOverviewCardProps[];
  selfProfileOverview: UserOverviewCardProps;
}

const baseTestID = OnboardingVerifyInfoTestID.Primary;

const OnboardingVerifyInfoPage = ({
  onNextPress,
  proxyPatientProfileOverviews,
  selfProfileOverview,
}: OnboardingVerifyInfoPageProps) => {
  return (
    <VStack gap={24}>
      <VStack gap={12}>
        <Text
          color={ColorToken.Primary90Variant}
          testID={joinTestIDs(baseTestID, TextTestID.Title)}
          variant="h2"
        >
          Let’s get started
        </Text>
        <Text
          color={ColorToken.Primary90Variant}
          testID={joinTestIDs(baseTestID, TextTestID.Description)}
          variant="body"
        >
          Please review the information below and make sure it’s correct.
        </Text>
      </VStack>
      {getUserOverviewCard(selfProfileOverview)}
      {proxyPatientProfileOverviews?.map(getUserOverviewCard)}
      <Button
        isFullWidth
        leftIcon={FAIconName.ArrowRight}
        onPress={onNextPress ?? noop}
        testID={baseTestID}
        title="Next"
        variant="primary"
      />
    </VStack>
  );
};

const getUserOverviewCard = (profileOverview: UserOverviewCardProps) => {
  const {
    address,
    analyticsSource,
    contactPreferences,
    fullName,
    gender,
    isAdditionalConsent = false,
    languages,
    phoneNumber,
    pronouns,
    selectedUserId,
    userType,
  } = profileOverview;
  return (
    <UserOverviewCard
      address={address}
      analyticsSource={analyticsSource}
      contactPreferences={contactPreferences}
      fullName={fullName}
      gender={gender}
      isAdditionalConsent={isAdditionalConsent}
      key={selectedUserId}
      languages={languages}
      phoneNumber={phoneNumber}
      pronouns={pronouns}
      selectedUserId={selectedUserId}
      userType={userType}
    />
  );
};

export default OnboardingVerifyInfoPage;
export { getUserOverviewCard };
export type { OnboardingVerifyInfoPageProps };
